import OutbrainCampaignModel from './OutbrainCampaignModel';
import ExportModel from '../../lib/ExportModel';

export default {
  async getConfig(account) {
    // Create Campaign Model
    const campaignModel = new OutbrainCampaignModel(account);
    return ExportModel(campaignModel);
  },
};
